import { render, staticRenderFns } from "./generic-sorting.vue?vue&type=template&id=e3561a32&scoped=true"
import script from "./generic-sorting.vue?vue&type=script&lang=js"
export * from "./generic-sorting.vue?vue&type=script&lang=js"
import style0 from "./generic-sorting.vue?vue&type=style&index=0&id=e3561a32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3561a32",
  null
  
)

export default component.exports